export const NOTIFICATION_PROMPT_OPTED_OUT_STORAGE_KEY = 'notification_prompt_opted_out';
